import React from 'react';
import PropTypes from 'prop-types';
import { Statistic, Tooltip, Icon } from 'antd';

import './index.scss';

import SpinnerLoader from '../../../../components/spinnerloader';

class ChartStatusCard extends React.PureComponent {
    renderLoader = () => {
        if (this.props.loading) {
            return (
                <div className="ori-absolute ori-align-full ori-bg-white ori-opacity-medium ori-border-radius-10">
                    <SpinnerLoader text="loading" />
                </div>
            );
        }
    };

    renderPercentChangeTag = () => {
        const { card_data } = this.props;
        if (card_data.changePercentage && card_data.changePercentage !== 0) {
            const changedValue = parseInt(card_data.changePercentage * 100);
            return (
                <div className={`ori-absolute ori-box-shadow-light ori-border-light ori-lr-pad-6 ori-bg-white ori-border-radius-15 ori-align-right-15 ori-align-top-neg-12 ${card_data.changePercentage > 0 ? "ori-font-green" : "ori-font-danger"}`}>
                    <Icon type={card_data.changePercentage > 0 ? "arrow-up" : "arrow-down"} className="ori-font-xs" />
                    <span className="ori-font-11 ori-l-pad-3">{changedValue > 0 ? changedValue : changedValue * -1}%</span>
                </div>
            );
        }
    };

    renderTooltipComponent = () => {
        const { card_data, tooltip_visible, value_key } = this.props;
        if (tooltip_visible)
            return (
                <div className="ori-pad-5">
                    <p className="ori-capitalize ori-font-md">{card_data.title}</p>
                    <p className="ori-capitalize ori-font-xs">{card_data.subtitle}</p>
                    <p className=" ori-font-md ori-font-primary">{card_data[value_key]}</p>
                    {
                        card_data.changePercentage && card_data.changePercentage !== 0 ?
                        <div>
                            <p className="ori-capitalize ori-font-xs">Percentage Change</p>
                            <p className={`ori-font-md ${card_data.changePercentage > 0 ? "ori-font-green" : "ori-font-danger"}`}>{card_data.changePercentage*100}%</p>
                        </div>
                        : null
                    }
                </div>
            );
        else return null;
    }

    render() {
        const { card_data, value_style, value_key } = this.props;
        let statistic_value = card_data[value_key];
        let statistic_suffix = card_data.suffix;
        let statistic_precision = card_data.precision;
        if (statistic_value && typeof (statistic_value) === 'number' && card_data[value_key] > 999) {
            if (card_data[value_key] < 100000) {
                statistic_suffix = 'K';
                statistic_value = card_data[value_key] / 1000;
                statistic_precision = card_data[value_key] % 1000 < 500 ? 0 : 1;
            } else if (card_data[value_key] < 10000000) {
                statistic_suffix = 'L';
                statistic_value = card_data[value_key] / 100000;
                statistic_precision = card_data[value_key] % 100000 < 50000 ? 0 : 1;
            } else {
                statistic_suffix = 'Cr';
                statistic_value = card_data[value_key] / 10000000;
                statistic_precision = card_data[value_key] % 10000000 < 5000000 ? 0 : 1;
            }
        }
        return (
            <Tooltip overlayClassName="ori-tooltip-arrow-hidden ori-tooltip-bg-white" title={this.renderTooltipComponent()}>
                <div className="ori-relative ori-animated ori-fade-in ori-full-width ori-pad-10 ori-border-radius-10 ori-bg-white ori-box-shadow-light ori-flex-row oriChartStatusCardContainer">
                    {this.renderPercentChangeTag()}
                    {this.renderLoader()}
                    <div className="ori-flex-column ori-flex-jc ori-flex-ac ori-overflow-hidden" style={{ width: '38%' }}>
                        <Statistic valueStyle={value_style} suffix={statistic_suffix} prefix={card_data.prefix} precision={statistic_precision} value={statistic_value} />
                    </div>
                    <div className="ori-flex-column ori-flex-jc ori-l-pad-10 ori-loader-line-height" style={{ width: '62%' }}>
                        <p className="ori-capitalize ori-font-bold ori-font-18 ori-text-overflow-dotted">{card_data.title}</p>
                        <p className="ori-capitalize ori-font-xs ori-text-overflow-dotted">{card_data.subtitle}</p>
                    </div>
                </div>
            </Tooltip>
        );
    }
}

ChartStatusCard.propTypes = {
    card_data: PropTypes.object,
    tooltip_visible: PropTypes.bool,
    loading: PropTypes.bool,
    value_style: PropTypes.object,
    value_key: PropTypes.string,
};

ChartStatusCard.defaultProps = {
    loading: false,
    value_style: { fontSize: '3.5rem', fontWeight: 'bold' },
    tooltip_visible: false,
    value_key: 'value',
};

export default ChartStatusCard;



// WEBPACK FOOTER //
// ./src/app/pagecontainer/components/chartstatuscard/index.js